import { SelectionCorporation, SelectionDataSource, SelectionAny } from './internal';
export class SelectionGedcomSource extends SelectionAny {
    getVersion() {
        return this.get("VERS" /* Tag.Version */);
    }
    getName() {
        return this.get("NAME" /* Tag.Name */);
    }
    getCorporation() {
        return this.get("CORP" /* Tag.Corporate */, null, SelectionCorporation);
    }
    getDataSource() {
        return this.get("DATA" /* Tag.Data */, null, SelectionDataSource);
    }
}
//# sourceMappingURL=SelectionGedcomSource.js.map